import { Section } from '../module-structure';
import { NzMessageService } from 'ng-zorro-antd/message';
import { LayoutService } from 'src/app/layout/layout.service';
import { RecordModel } from 'src/app/layout/record-model';
import { ModuleStructure } from '../module-structure';

export class businessPartners {
  constructor(
    private layoutService: LayoutService,
    private messageService: NzMessageService
  ) {
    layoutService.objectLoadChanged.subscribe(
      (args: {
        recordModel: RecordModel;
        moduleStructure: ModuleStructure;
      }) => {
        try {
          if (args.recordModel.ObjectTypeValue !== '2') {
            return;
          }

          const category = args.recordModel.Categories.find(
            (c) => c.Id === 'BusinessPartners'
          );
          const cardType = category.Lines[0].Properties.find(
            (p) => p.Name === 'CardType'
          ).ValueAsObject;

          args.moduleStructure.module.Sections.forEach((section) => {
            if (cardType !== 'S' && section.TabGroup === 'main-vndr') {
              section.AdditionalInformationParsed.Hidden = true;
            } else if (cardType === 'S' && section.TabGroup === 'main') {
              section.AdditionalInformationParsed.Hidden = true;
            }
          });

          this.layoutService.moduleStructureChanged.emit('');
        } catch (e) {
          console.log('error during loading the object, the error is:', e);
        }
      }
    );
  }
}
